<template>
  <div class="log">
    <basic-container>
      <avue-crud
        ref="crud"
        :page.sync="page"
        :data="tableData"
        :table-loading="tableLoading"
        :option="tableOption"
        v-model="form"
        @search-change="searchChange"
        :search.sync="search"
        @search-reset="searchRest"
        @refresh-change="refreshChange"
        @selection-change="selectionChange"
        @size-change="sizeChange"
        @current-change="currentChange"
      >
        <template slot="menuLeft" slot-scope="{ size }">
          <el-button type="primary" :size="size" @click="openAddOrEdit('add')">
            新增
          </el-button>
          <el-button type="primary" :size="size" @click="btnImport()">
            批量导入
          </el-button>
          <el-button type="primary" :size="size" @click="openBatchAct">
            批量操作实习状态
          </el-button>
        </template>
        <template slot-scope="{ disabled, size }" slot="search">
          <el-form-item label-width="170px" label="译员昵称/姓名/手机号码">
            <el-input
              class="w-120"
              placeholder="请输入"
              :disabled="disabled"
              size="mini"
              v-model="search.trInfo"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label-width="110px" label="已提交包数≤">
            <el-input
              class="w-95"
              @input.native="handlerEditNum($event)"
              placeholder="请输入数字"
              size="mini"
              v-model="search.taskCount"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label-width="110px" label="已提交字数≤">
            <el-input
              class="w-95"
              @input.native="handlerEditNum($event)"
              placeholder="请输入数字"
              size="mini"
              v-model="search.wordCount"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label-width="80px" label="实习批次">
            <el-select v-model="search.batchNo" placeholder="请选择" clearable>
              <el-option
                v-for="(item, index) in batchList"
                :key="index"
                :value="item.batchNo"
                :label="`第${item.batchNo}批`"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label-width="50px" label="语种">
            <el-select v-model="search.lan" placeholder="请选择" clearable>
              <el-option
                v-for="(item, index) in langList"
                :key="index"
                :value="item.value"
                :label="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
        </template>
        <template slot="nickName" slot-scope="scope">
          {{ scope.row.nickname }}【{{ scope.row.realName }}】
        </template>
        <template slot="batchNo" slot-scope="scope">
          第{{ scope.row.batchNo }}批
        </template>
        <template slot-scope="scope" slot="markingStatus">
          <avue-switch
            inactive-color="#13ce66"
            active-color="#ff4949"
            v-model="scope.row.markingStatus"
            @click="markingStatusChange(scope.row)"
            :dic="dic"
          ></avue-switch>
        </template>
        <template slot-scope="scope" slot="peStatus">
          <avue-switch
            inactive-color="#13ce66"
            active-color="#ff4949"
            v-model="scope.row.peStatus"
            @click="peStatusChange(scope.row)"
            :dic="dic"
          ></avue-switch>
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button
            size="small"
            type="text"
            @click="openAddOrEdit('edit', scope.row)"
          >
            编辑
          </el-button>
        </template>
      </avue-crud>
    </basic-container>

    <!-- 新增/编辑实习译员 -->
    <el-dialog
      v-if="dialogAdd"
      @close="closeAddOrEdit"
      :visible.sync="dialogAdd"
      :close-on-click-modal="false"
      :title="actType == 'add' ? '新增实习译员' : '编辑实习生'"
    >
      <div class="c-primary f-s-12 m-b-10">
        新增的实习译员，系统将自动注册到实习译员池，只能处理实习顶目，不能承接其他常规DOT任务:（如已注册过且已拥有常规DOT能力，将可同时承接实习项目和常规DOT项目）
      </div>
      <el-form
        label-position="right"
        label-width="80px"
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
      >
        <el-form-item label="手机号" prop="phone">
          <el-input
            v-model="ruleForm.phone"
            :disabled="actType == 'edit'"
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="ruleForm.email" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="真实姓名" prop="realName">
          <el-input v-model="ruleForm.realName"></el-input>
        </el-form-item>
        <el-form-item label="实习批次" prop="batchNo">
          第
          <el-input-number
            class="m-lr-5"
            v-model="ruleForm.batchNo"
            :min="1"
            :precision="0"
            :step="1"
            :disabled="actType == 'edit'"
          ></el-input-number>
          批
        </el-form-item>
        <el-form-item label="毕业院校">
          <el-input v-model="ruleForm.school"></el-input>
        </el-form-item>
        <el-form-item label="语种1" prop="lan1">
          <el-select v-model="ruleForm.lan1" placeholder="请选择" clearable>
            <el-option
              v-for="(item, index) in langList"
              :key="index"
              :value="item.value"
              :label="item.name"
              :disabled="item.value == ruleForm.lan2"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="语种2">
          <el-select v-model="ruleForm.lan2" placeholder="请选择" clearable>
            <el-option
              v-for="(item, index) in langList"
              :key="index"
              :value="item.value"
              :label="item.name"
              :disabled="item.value == ruleForm.lan1"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addPractice">确 定</el-button>
        <el-button @click="closeAddOrEdit">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 批量导入 -->
    <el-dialog
      :visible.sync="dialogFormImport"
      title="批量导入"
      width="50%"
      @close="dialogFormImport = false"
    >
      <span>下载模板，为提高导入的成功率，请下载并使用系统提供的模板</span>
      <el-button
        style="margin-left: 20px"
        type="success"
        size="small"
        @click="downLoadTemplate()"
      >
        下载exlce模板
      </el-button>
      <div class="d-f">
        <span class="p-l-30 p-r-5 p-t-20">
          <span style="color: red">*</span>
          实习译员导入excel:
        </span>
        <el-upload
          ref="upload"
          class="upload-demo p-15"
          :before-upload="beforeUpload"
          :on-success="handleSuccess"
          :on-error="handleError"
          :auto-upload="false"
          drag
          :data="importObj"
          :limit="1"
          :action="uploadurl"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            请上传excle,只支持单sheet 权限列：启用/禁用, 信用分值列：0-100的整数
          </div>
        </el-upload>
      </div>
      <div class="d-f align-c">
        <span class="p-l-30 p-r-5">
          <span style="color: red">*</span>
          本批次实习译员语种:
        </span>
        <el-select v-model="batchLang" placeholder="请选择" clearable>
          <el-option
            v-for="(item, index) in langList"
            :key="index"
            :value="item.value"
            :label="item.name"
          ></el-option>
        </el-select>
        <span class="f-s-12 m-l-5">说明：系统会支持中文到此语种的双向能力</span>
      </div>
      <div slot="footer" class="dialog-footer t-c">
        <el-button type="primary" @click="importSubmit">提 交</el-button>
        <el-button @click="dialogFormImport = false">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 批量操作实习状态 -->
    <el-dialog :visible.sync="dialogAct" title="批量操作实习状态" width="50%">
      <el-table :data="batchList" border :size="small" max-height="300px">
        <el-table-column prop="batchNo" label="实习批次" align="center">
          <template slot-scope="scope">
            <span style="white-space: pre">第{{ scope.row.batchNo }}批</span>
          </template>
        </el-table-column>
        <el-table-column prop="internNum" label="实习人数" align="center">
          <template slot-scope="scope">
            {{ scope.row.internNum }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="实习状态" align="center">
          <template slot-scope="scope">
            <span style="white-space: pre">
              {{ scope.row.status == 1 ? '实习中' : '实习结束' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="endTime"
          label="结束时间"
          align="center"
          width="150px"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.endTime">
              {{ scope.row.endTime | parseTime }}
            </span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="操作" align="center" width="150px">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 2 && !scope.row.internUrl">
              正在生成，请稍等……
            </span>
            <el-button
              v-if="scope.row.status == 2 && scope.row.internUrl"
              type="text"
              size="mini"
              class="c-danger"
              @click="downloadDataInfo(scope.row.internUrl)"
            >
              下载实习明细数据表
            </el-button>
            <el-button
              v-if="scope.row.status == 1"
              type="text"
              size="mini"
              @click="practiceEnd(scope.row)"
            >
              结束实习
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer"></span>
    </el-dialog>
  </div>
</template>

<script>
import {
  internPage,
  internBatchList,
  addIntern,
  finishInternBatch,
  getLan,
  getIntern,
  updateIntern,
} from '@/api/resource/practiceList';
import { statistics } from '@/api/dot/flow';
import { tableOption } from '@/const/crud/resource/practiceList';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'practice',
  data() {
    const checkPhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入联系方式'));
      } else {
        const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error('请输入正确的电话'));
        }
      }
    };
    return {
      batchList: [], //实习批次集合
      dialogAdd: false, //新增弹窗显示状态
      dialogAct: false, //批量操作弹窗状态
      ruleForm: {
        phone: '',
        email: '',
        realName: '',
        batchNo: null,
        school: '',
        lan1: '',
        lan2: '',
      },
      rules: {
        phone: [
          {
            required: true,
            message:
              '请输入正确的手机号，否则影响译员接收实习订单推送以及修改密码等常规操作',
            trigger: 'blur',
          },
          { validator: checkPhone, trigger: 'blur' },
        ],
        realName: [
          { required: true, message: '请输入真实姓名', trigger: 'blur' },
          {
            required: true,
            transform: (value) => value && value.trim(),
            message: '姓名不能为空',
            trigger: 'blur',
          },
        ],
        batchNo: [
          { required: true, message: '请输入实习批次', trigger: 'blur' },
        ],
        lan1: [{ required: true, message: '请选择语种', trigger: 'change' }],
      },
      hideFlag: null,
      prohibitFlag: null,
      form: {},
      dialogFormImport: false, //表格显示隐藏
      dialogFormExport: false, //表格显示隐藏
      dic: [
        {
          value: 1,
        },
        {
          value: 2,
        },
      ],
      tableData: [],
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示多少条
      },
      tableLoading: false,
      importObj: {},
      exportObj: {},
      statusObj: {},
      idList: [],
      tableOption: tableOption,
      exportOption: {},
      staParams: null,
      uploadurl: '',
      search: {
        trInfo: null,
        taskCount: null,
        wordCount: null,
        batchNo: null,
        lan: null,
      },
      langList: [],
      batchLang: '',
      actType: null,
      currentRow: null,
    };
  },
  computed: {
    ...mapGetters(['permissions', 'userInfo']),
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.curPath = to.path;
      vm.oldPath = from.path;
    });
  },

  created() {
    this.getLangList();
    this.getBatchList();
  },

  mounted() {
    this.uploadurl = this.baseUrl + '/dotadmin/dotIntern/bulkAddIntern';
    this.getList(this.page, this.search);
    this.staParams = {
      u_id: this.userInfo.staffId,
      time: new Date().getTime(),
      browser: navigator.userAgent.toLowerCase(),
      url: document.URL,
      scene_name: '实习译员池',
    };
    this.statistics();
  },

  methods: {
    getLangList() {
      getLan().then((res) => {
        console.log(res.data?.data);
        let data = res.data?.data;
        for (var key in data) {
          var temp = {};
          if (data[key] != '') {
            temp.value = key;
            temp.name = data[key];
            this.langList.push(temp);
          }
        }
      });
    },
    // 限制数字输入框
    handlerEditNum(e) {
      e.target.value = e.target.value.replace(/[^0-9]/g, '');
    },

    // 获取实习译员池列表
    getList(page, params) {
      this.tableLoading = true;
      internPage(
        Object.assign(
          {
            current: page.currentPage,
            size: page.pageSize,
          },
          params,
        ),
      ).then((res) => {
        this.tableData = res?.data?.data?.records || [];
        this.page.total = res?.data?.data?.total;
        this.tableLoading = false;
      });
    },

    statistics() {
      statistics(
        Object.assign(
          {
            event_type: 'view',
            ref_url: this.oldPath,
          },
          this.staParams,
        ),
      );
    },

    // 获取实习批次
    getBatchList() {
      internBatchList({}).then((res) => {
        this.batchList = res?.data?.data || [];
      });
    },

    // 打开新增/编辑弹窗
    openAddOrEdit(type, row) {
      this.actType = type;
      this.currentRow = row;
      if (type == 'edit') {
        getIntern({
          trId: row.trId,
        }).then((res) => {
          const lang = res.data?.data?.lan.split(',');
          this.ruleForm.phone = res.data?.data?.phone;
          this.ruleForm.email = res.data?.data?.email;
          this.ruleForm.realName = res.data?.data?.realName;
          this.ruleForm.batchNo = res.data?.data?.batchNo;
          this.ruleForm.school = res.data?.data?.remark;
          this.ruleForm.lan1 = lang[0];
          this.ruleForm.lan2 = lang[1] ? lang[1] : '';
        });
      }
      this.dialogAdd = true;
    },

    // 关闭新增/编辑弹窗
    closeAddOrEdit() {
      this.dialogAdd = false;
      this.resetForm();
    },

    // 新增/编辑实习译员
    addPractice() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) {
          return;
        } else {
          const lang = this.ruleForm.lan2
            ? this.ruleForm.lan1 + ',' + this.ruleForm.lan2
            : this.ruleForm.lan1;
          if (this.actType == 'add') {
            addIntern({
              phone: this.ruleForm.phone,
              email: this.ruleForm.email,
              realName: this.ruleForm.realName,
              batchNo: this.ruleForm.batchNo,
              remark: this.ruleForm.school,
              lan: lang,
            }).then((res) => {
              this.$message.success('新增成功');
              this.dialogAdd = false;
              this.getList(this.page, this.search);
              this.resetForm();
            });
          } else {
            updateIntern({
              id: this.currentRow.trId,
              email: this.ruleForm.email,
              realName: this.ruleForm.realName,
              remark: this.ruleForm.school,
              lan: lang,
            }).then((res) => {
              this.$message.success('编辑成功');
              this.dialogAdd = false;
              this.getList(this.page, this.search);
              this.resetForm();
            });
          }
        }
      });
    },

    resetForm() {
      this.ruleForm.phone = '';
      this.ruleForm.email = '';
      this.ruleForm.realName = '';
      this.ruleForm.batchNo = null;
      this.ruleForm.school = '';
      this.ruleForm.lan1 = '';
      this.ruleForm.lan2 = '';
    },

    // 打开批量操作实习状态弹窗
    openBatchAct() {
      this.getBatchList();
      this.dialogAct = true;
    },

    // 结束实习
    practiceEnd(row) {
      this.$confirm(
        `你确定要结束“第${row.batchNo}批”所有人员的实习吗?`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        },
      )
        .then(() => {
          finishInternBatch({
            id: row.id,
          }).then((res) => {
            this.$message.success('操作成功');
            this.getBatchList();
          });
        })
        .catch(() => {});
    },

    // 下载实习数据明细表
    downloadDataInfo(url) {
      window.location.href = url;
    },

    // 译员清空有问题
    searchRest(form) {
      this.search.id = '';
    },

    // 上传文件之前的钩子, 参数为上传的文件,若返回 false 或者返回 Promise 且被 reject，则停止上传
    beforeUpload(file) {
      let extension = file.name.substring(file.name.lastIndexOf('.') + 1);
      let size = file.size / 1024 / 1024;
      if (extension.indexOf('xls') > 0) {
        this.$message.warning('只能上传后缀是.xlsx或者.xls的文件');
      }
      // if (size > 10) {
      //   this.$message.warning("文件大小不得超过10M");
      // }
    },

    // 文件上传成功
    handleSuccess(res, file, fileList) {
      if (res.code === 0) {
        this.$message.success('文件上传成功！');
        this.getList(this.page, this.getList);
        this.$refs.upload.clearFiles(); //清空文件
      } else {
        this.$message.error(res.msg);
        this.$refs.upload.clearFiles(); //清空文件
      }
    },

    // 文件上传失败
    handleError(err, file, fileList) {
      this.$message.error('文件上传失败');
      this.$refs.upload.clearFiles(); //清空文件
    },

    // 下载模版
    downLoadTemplate() {
      window.open(
        'https://filemanager.woordee.com/intern-template.xlsx',
        '_self',
        '',
      );
    },

    // 打开批量导入弹窗
    btnImport() {
      this.dialogFormImport = true;
    },

    // 批量导入
    importSubmit() {
      console.log(this.uploadurl);
      if (!this.batchLang) {
        this.$message.warning('请选择语种');
        return;
      }
      this.importObj.userName = this.userInfo.username;
      this.importObj.lan = this.batchLang;
      this.$refs.upload.submit();
      this.dialogFormImport = false;
      this.batchLang = '';
    },

    handleBeforeUpload(file) {
      this.$message.success(file);
    },

    selectionChange(list) {
      this.idList = list.map((it) => it.id);
    },

    searchChange(form, done) {
      this.search = form;
      this.page.currentPage = 1; //避免翻页了再搜索为空的情况，明明应该有数据
      this.getList(this.page, form);
      done();
      statistics(
        Object.assign(
          {
            event_name: '搜索',
            event_type: 'click',
          },
          this.staParams,
        ),
      );
    },

    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.getList(this.page, this.search);
    },

    currentChange(current) {
      this.page.currentPage = current;
      this.getList(this.page, this.search);
    },

    refreshChange() {
      this.getList(this.page, this.search);
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(label[for='nickName']) {
  display: none;
}
.item {
  margin-top: 10px;
  margin-right: 25px;
}
</style>
